// perhaps make like the fake line used for rect on scale resize
// this could also just be a wrapper around the rEl
// TODO: With untransformed shapes ( eg text stamp ), there are more optimal ways to handle now


var Marionette = require('marionette'),
    Raphael = require('raphael'),//(imported by Raphael view, but gets Sonar to shut up)
    RaphaelView = require('raphaelItemView');

var instVars = {
    ox: null,
    oy: null
};

module.exports = RaphaelView.extend({

    svgAttrs: {
        stroke: '#33A645',
        'stroke-width': 1,
        'stroke-linejoin': 'miter',
        fill: 'none'
         //'stroke-dasharray': '--' -- if use this may not want to transform, it doesn't look good ( see spiders, redraw path -- but for text stamps, we don't resize )
    },

    initialize: function(options) {

        _.extend( this, instVars );

        this.bindEntityEvents( options.parent, this.parentSubs );

    },
    parentSubs: {
        'shape.move':                       'move',
        'shape.resizeSelectBox':            'resize',   //for now the same event listened to by this resize handlers -- much faster than resizeFree -- TODO: CHANGE RESIZE
        'shape.onAfterBaseScale':           'setPathToBBoxOfParent',
        'shape.selectBox.resetPath':        'setPathToBBoxOfParent',
        'shape.moveEnd shape.resizeEnd':    'bakeTransform'
    },

    render: function(shapeEl) {

        var bboxPath = shapeEl.getPathOfBBox(),
            borderPath = shapeEl.paper.path(bboxPath).attr( this.svgAttrs );

        this.setElement(borderPath);

        this.el
            .attr('cursor', 'move')
            .data('shapeType', 'selectBox')
            .insertBefore(shapeEl); //position above handle but not in front of shape

        this.ox = this.el.attr('x');
        this.oy = this.el.attr('y');

        return this;

    },
    move: function( box, dx, dy ) {

        this.el.transform( 'T' + (this.ox + dx) + " " + (this.oy + dy) );  /* Note: Use This for Perf -- Not the Dashed LIne*/

    },
    resize: function( parentTrans ) {
        //var p = Raphael.mapPath(this.el.attr('path'), shapeMatrix); // perhaps need mapPathStraight()...
        this.el.transform( parentTrans );
    },
    // perhaps rid cachedBox in this but this isn't always the same transform
    bakeTransform: function() {

       // this.el.removeCachedBox(); -- doesn't fix

        this.el
            .bakeTransform()
            .attr('stroke-width', this.svgAttrs['stroke-width']);

    },

    /**
     * Set removeTransform to true now only done on move end of 'transformed' shapes
     */
    setPathToBBoxOfParent: function( box, removeTransform ) {

        this.el.attr( 'path', Raphael.fn.rectPath(box.x, box.y, box.width, box.height) );

        if ( removeTransform ) {
            this.el.transform( '' );
        }

    },

    onBeforeDestroy: function() {


        this.unbindEntityEvents(this, this.parentSubs);
    }

});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/views/shape/selectSet/selectBox.js
 ** module id = 206
 ** module chunks = 0
 **/